import './css/styles.scss';

// Swiper JS + moduler. OBS: vi importerar INTE swiper/css (den stylar globalt
// alla .swiper/.swiper-slide och krockar med andra slidrar). Egna klasser
// (pbg-*) + egen scoped CSS i styles.scss istället.
import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';

function initProduktbildGalleri() {
	const sliders = document.querySelectorAll<HTMLElement>(
		'.produktbild-galleri__swiper'
	);
	if (!sliders.length) return;

	sliders.forEach((el) => {
		new Swiper(el, {
			modules: [Navigation],
			// Egna klassnamn så inget krockar med andra slidrar.
			wrapperClass: 'pbg-wrapper',
			slideClass: 'pbg-slide',
			slidesPerView: 2, // 2 bilder i vyn
			slidesPerGroup: 1, // flytta 1 bild åt gången vid swipe
			spaceBetween: 16,
			loop: true, // loopa så man kan scrolla även med få bilder
			watchOverflow: false, // håll slidern aktiv även om alla bilder ryms
			navigation: {
				nextEl: el.querySelector<HTMLElement>('.pbg-button-next'),
				prevEl: el.querySelector<HTMLElement>('.pbg-button-prev'),
			},
			breakpoints: {
				0: { slidesPerView: 1 }, // mobil: 1 bild
				600: { slidesPerView: 2 }, // över 600px: 2 bilder
			},
		});
	});
}

// Kör efter att DOM är redo (scriptet kan laddas före markup).
if (document.readyState !== 'loading') {
	initProduktbildGalleri();
} else {
	document.addEventListener('DOMContentLoaded', initProduktbildGalleri);
}
